/* eslint-disable array-callback-return */
import React from "react";
import { useState, useEffect, useRef } from "react";
import {
  assessmentFlow,
  AccountType,
  assignmentStatus,
} from "../../components/constants/constants";
import { find, size } from "lodash";
import Sidebar from "./Sidebar";
// import SpeakFooter from "./SpeakFooter";
// import { SpeakButtons } from "./SpeakButtons";
import SpeakQuizBody from "./SpeakQuizBody";
import SpeakQuestionInfo from "../components/SpeakQuestionInfo";
import SpeakStartPage from "./SpeakStartPage";
import { useMobileView } from "../components/MobileViewContext";
import MobileSidebar from "./MobileSidebar";
let visited_pages = [];
let pagination_color_decision = [];
export const SpeakTestRunner = ({
  assessmentStarted,
  isReview,
  systemrequirementToggle,
  data,
  isStopTimer,
  setIsStopTimer,
  IsonRecorder,
  setIsonRecorder,
  timer,
  setTestStatus,
  testStatus,
  additionalResourceToggle,
  setSpeakingUrl,
  currentPage,
  onblur,
  answers,
  resetAudio,
  setresetAudio,
  setCurrentPage,
  creatQuizDataAndSubmit,
  isSubmitting,
  setShowTimeWarning,
  visualizerToggle,
  setessayWordsCount,
}) => {
  const { isMobileView, observedDiv } = useMobileView();
  const [ShowAssessmentInfo, setShowAssessmentInfo] = useState(true);
  const [assessmentData, setAssessmentData] = useState(data);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [AisubmissionCounter, setAisubmissionCounter] = useState(
    data?.remaining_credits
  );
  const [GWarningModal, setGWarningModal] = useState(false);
  const lastexerciseId = useRef(null);
  const GWarningToggle = () => setGWarningModal(!GWarningModal);
  useEffect(() => {
    setAssessmentData(data);
    setAisubmissionCounter(data?.remaining_credits);
  }, [data]);
  const [CurrentSection, setCurrentSection] = useState(1);
  const [currentPageOfSection, setCurrentPageOfSection] =
    useState(CurrentSection);

  const [currentSectionPage, setcurrentSectionPage] = useState(11);
  const [currentSectionPageOnSection, setcurrentSectionPageOnSection] =
    useState(currentSectionPage);

  useEffect(() => {
    setcurrentSectionPageOnSection(currentSectionPage);
  }, [currentSectionPage]);

  useEffect(() => {
    setCurrentPageOfSection(CurrentSection);
  }, [CurrentSection]);

  useEffect(() => {
    if (data.completed_at && data.completed_at !== null && data.sections) {
      setCurrentSection(data.sections[0].section_number);
      setcurrentSectionPage(`${data.sections[0].section_number}1`);
    }
  }, [data]);

  if (data.completed_at && data.completed_at !== null) {
    isReview = true;
    setIsStopTimer(true);
  }

  useEffect(() => {
    const handleUserInteraction = () => setHasUserInteracted(true);
    document.addEventListener("click", handleUserInteraction, { once: true });
    return () => {
      document.removeEventListener("click", handleUserInteraction);
    };
  }, []);

  let isAiGradingexercise;
  return (
    <div ref={observedDiv} data-tc="assessment-start-page">
      {assessmentData && assessmentData.sections && (
      <div className={`col-12 ${isMobileView? "":"d-flex"} full-height-div`}>
        {isMobileView ? (
          <MobileSidebar
            data={assessmentData}
            answers={answers}
            currentPage={CurrentSection}
          />
        ) : (
          <div className={`border-side side-width`}>
            <Sidebar
              data={assessmentData}
              answers={answers}
              visited_pages={visited_pages}
              currentPage={CurrentSection}
              setCurrentPage={setCurrentSection}
              currentSectionPage={currentSectionPage}
              setCurrentSectionPage={setcurrentSectionPage}
              pagination_color_decision={pagination_color_decision}
              isAiGradingexercise={isAiGradingexercise}
              AisubmissionCounter={AisubmissionCounter}
              setAisubmissionCounter={setAisubmissionCounter}
            />
          </div>
        )}

        <div className={`${!isMobileView && "container"} speak-container px-0`}>
          <div className="row g-0 justify-content-center h-100">
            <div className="col-12">
              <div className={`row g-0`}>
                {assessmentData && assessmentData.sections && (
                  <div className="px-0">
                    {isMobileView && (
                      <p className="border-top mx-2 mt-2"></p>
                    )}
                    {assessmentData.sections.map((section, id) => {
                      if (
                        parseInt(currentPageOfSection) ===
                          parseInt(section.section_number) ||
                        (assessmentData.assessment_flow ===
                          assessmentFlow.SEQUENTIAL_EARLY_STOP &&
                          data.user_type === AccountType.STUDENT &&
                          !isReview)
                      ) {
                        if (!ShowAssessmentInfo) {
                          setShowAssessmentInfo(true);
                        }
                        if (
                          section.instruction !== "" &&
                          section.instruct_audio &&
                          !localStorage.getItem(
                            `ShowInfo${assessmentData.student_assessment_id}${section.id}`
                          )
                        ) {
                          return (
                            <SpeakQuestionInfo
                              data={assessmentData}
                              assessmentStarted={assessmentStarted}
                              section={section}
                              setShowAssessmentInfo={setShowAssessmentInfo}
                              hasUserInteracted={hasUserInteracted}
                            />
                          );
                        }
                        return (
                          section &&
                          section.pages.map((page, id) => {
                            if (
                              parseInt(currentSectionPageOnSection) ===
                                parseInt(
                                  `${section.section_number}${page.page_number}`
                                ) ||
                              (assessmentData.assessment_flow ===
                                assessmentFlow.SEQUENTIAL_EARLY_STOP &&
                                data.user_type === AccountType.STUDENT &&
                                !isReview)
                            ) {
                              // pagesOfCurrentSection = section.total_pages;
                              // bottomPanelSection = section.section_number;
                              // bottomPanelPage = page.page_number;
                              if (page.writing_exercises.length === 0) {
                                return (
                                  page &&
                                  page.exercises.map(
                                    (exercise, exercise_id) => {
                                      isAiGradingexercise =
                                        exercise.ai_grading_task;
                                      let found_selected_answer = find(
                                        visited_pages,
                                        [
                                          "section_number",
                                          section.section_number,
                                        ]
                                      );
                                      if (found_selected_answer) {
                                        let found_exercise = find(
                                          found_selected_answer.pages,
                                          ["exercise_id", exercise.id]
                                        );
                                        if (!found_exercise) {
                                          found_selected_answer.pages.push({
                                            exercise_total_questions: size(
                                              exercise.questions
                                            ),
                                            page_number: page.page_number,
                                            exercise_questions:
                                              exercise.questions,
                                            page_id: page.id,
                                            exercise_id: exercise.id,
                                            pagination_number:
                                              currentSectionPage,
                                          });
                                        }
                                      } else {
                                        visited_pages.push({
                                          section_number:
                                            section.section_number,
                                          pages: [
                                            {
                                              exercise_total_questions: size(
                                                exercise.questions
                                              ),
                                              page_number: page.page_number,
                                              exercise_questions:
                                                exercise.questions,
                                              page_id: page.id,
                                              exercise_id: exercise.id,
                                              pagination_number:
                                                currentSectionPage,
                                            },
                                          ],
                                        });
                                      }
                                      if (
                                        !assessmentStarted &&
                                        data.status === assignmentStatus.New
                                      ) {
                                        return (
                                          <>
                                            <div className="px-0">
                                              <SpeakStartPage
                                                section_id={section.id}
                                                page_id={page.id}
                                                section={section}
                                                exercise={exercise}
                                                isStopTimer={isStopTimer}
                                                setIsStopTimer={setIsStopTimer}
                                                setIsonRecorder={
                                                  setIsonRecorder
                                                }
                                                isReview={isReview}
                                                systemrequirementToggle={
                                                  systemrequirementToggle
                                                }
                                                setTestStatus={setTestStatus}
                                                testStatus={testStatus}
                                                additionalResourceToggle={
                                                  additionalResourceToggle
                                                }
                                                resetAudio={resetAudio}
                                                setresetAudio={setresetAudio}
                                                setSpeakingUrl={setSpeakingUrl}
                                                currentPage={currentPage}
                                                onblur={onblur}
                                                answers={answers}
                                                data={assessmentData}
                                                visualizerToggle={
                                                  visualizerToggle
                                                }
                                                setessayWordsCount={
                                                  setessayWordsCount
                                                }
                                                isAiGradingexercise={
                                                  isAiGradingexercise
                                                }
                                                GWarningToggle={GWarningToggle}
                                                AisubmissionCounter={
                                                  AisubmissionCounter
                                                }
                                                lastexerciseId={lastexerciseId}
                                                creatQuizDataAndSubmit={
                                                  creatQuizDataAndSubmit
                                                }
                                                isSubmitting={isSubmitting}
                                              />
                                            </div>
                                          </>
                                        );
                                      } else {
                                        return (
                                          <>
                                            <div>
                                              <SpeakQuizBody
                                                section_id={section.id}
                                                page_id={page.id}
                                                section={section}
                                                exercise={exercise}
                                                isStopTimer={isStopTimer}
                                                setIsStopTimer={setIsStopTimer}
                                                setIsonRecorder={
                                                  setIsonRecorder
                                                }
                                                isReview={isReview}
                                                systemrequirementToggle={
                                                  systemrequirementToggle
                                                }
                                                setTestStatus={setTestStatus}
                                                testStatus={testStatus}
                                                additionalResourceToggle={
                                                  additionalResourceToggle
                                                }
                                                resetAudio={resetAudio}
                                                setresetAudio={setresetAudio}
                                                setSpeakingUrl={setSpeakingUrl}
                                                currentPage={currentPage}
                                                onblur={onblur}
                                                answers={answers}
                                                data={assessmentData}
                                                visualizerToggle={
                                                  visualizerToggle
                                                }
                                                setessayWordsCount={
                                                  setessayWordsCount
                                                }
                                                isAiGradingexercise={
                                                  isAiGradingexercise
                                                }
                                                GWarningToggle={GWarningToggle}
                                                AisubmissionCounter={
                                                  AisubmissionCounter
                                                }
                                                lastexerciseId={lastexerciseId}
                                                creatQuizDataAndSubmit={
                                                  creatQuizDataAndSubmit
                                                }
                                                isSubmitting={isSubmitting}
                                                hasUserInteracted={hasUserInteracted}
                                              />
                                            </div>
                                          </>
                                        );
                                      }
                                    }
                                  )
                                );
                              }
                            }
                          })
                        );
                      }
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* {assessmentData && assessmentData.sections && (
          <Row className="col-12 pe-5 g-0">
            <div className={`col-12 fixed-bottom-btns d-flex justify-content-end px-3 ${isMobileView && "border-top"}`}>
              <div
                className={
                  isReview ||
                  assessmentData.assessment_flow ===
                    assessmentFlow.SEQUENTIAL_EARLY_STOP
                    ? "col-12 ps-0"
                    : "col-6"
                }
              >
                <SpeakFooter/> */}
                {/* <SpeakButtons
                  data={assessmentData}
                  testStatus={testStatus}
                  IsonRecorder={IsonRecorder}
                  pagesOfCurrentSection={pagesOfCurrentSection}
                  currentSection={bottomPanelSection}
                  setCurrentSection={setCurrentSection}
                  currentSectionPage={bottomPanelPage}
                  setCurrentSectionPage={setcurrentSectionPage}
                  total_sections={
                    assessmentData &&
                    assessmentData.sections &&
                    assessmentData.sections.length
                  }
                  isSubmitting={isSubmitting}
                  isReview={isReview}
                /> */}
{/*                 
              </div>
            </div>
          </Row>
          )} */}
        </div>
      </div>
      )}
    </div>
  );
};
